(function () {
  function initBlogHub(root) {
    if (!root || root.dataset.smartlifeBlogInitialized === 'true') return;
    root.dataset.smartlifeBlogInitialized = 'true';
    var input = root.querySelector('[id^="SmartLifeBlogSearch-"]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-blog-card]'));
    var noResults = root.querySelector('[data-no-results]');
    var visibleCount = root.querySelector('[data-visible-count]');
    var clearBtn = root.querySelector('[data-clear-search]');

    function normalize(value) {
      return (value || '')
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
    }

    function filterCards() {
      if (!input) return;

      var query = normalize(input.value);
      var count = 0;

      cards.forEach(function (card) {
        var haystack = normalize(card.getAttribute('data-search'));
        var match = query === '' || haystack.indexOf(query) !== -1;

        card.style.display = match ? '' : 'none';
        card.setAttribute('aria-hidden', match ? 'false' : 'true');

        if (match) {
          count += 1;
        }
      });

      if (visibleCount) {
        visibleCount.textContent = count;
      }

      if (noResults) {
        noResults.classList.toggle('is-visible', count === 0);
        noResults.setAttribute('aria-hidden', count === 0 ? 'false' : 'true');
      }

      if (clearBtn) {
        clearBtn.classList.toggle('is-visible', query !== '');
        clearBtn.hidden = query === '';
      }
    }

    if (input) {
      input.addEventListener('input', filterCards);
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        filterCards();
        input.focus();
      });
    }

    filterCards();
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-smartlife-blog-hub]').forEach(initBlogHub); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { initAll(document); }); else initAll(document);
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
})();
